module.exports = __webpack_public_path__ + "images/floorplan-9ae704428eab5c0da9afd8b930e98e82.jpg";